import { House } from "lucide-react";

import { createNavigationLucideIcon } from "./createNavigationLucideIcon";

export const HomeIcon = createNavigationLucideIcon(House);
